import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, of, Subscription } from 'rxjs';

import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { UserStateModel } from '../../../../Core/Users/models/user-state.model';

import { LoginApi } from '../../../../api/login/login.api';
import { WebsocketAwareNeptuneService } from '../../../../Bootstrap/services/websocket-aware-neptune.service';
import { HttpVerbsEnum } from '../../../../api/shared/enums/http-verbs.enum';

@Component({
    selector: 'agpr-impersonator-banner',
    templateUrl: './impersonator-banner.component.html',
    styleUrls: ['./impersonator-banner.component.scss'],
    standalone: false
})
export class ImpersonatorBannerComponent implements OnDestroy {
    subscriptions: Subscription[] = [];

    userState: UserStateModel;

    loading: boolean = false;

    constructor(
        private userStateService: CurrentUserStateService,
        private loginApi: LoginApi,
        private router: Router,
        private websocketAwareNeptuneService: WebsocketAwareNeptuneService
    ) {
        this.subscriptions.push(
            this.userStateService.getState().subscribe(userState => this.userState = userState)
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptions.length = 0;
    }

    ghostOut() {
        this.loading = true;
        this.loginApi.ghostOut().pipe(
            catchError((error) => {
                this.loading = false;
                return of(null);
            })
        ).subscribe(token => {
            if (token) {
                this.userStateService.clearState();
                this.userStateService.loadUserState();
                this.websocketAwareNeptuneService.sendWebsocketEventInstant('/login/ghostin', HttpVerbsEnum.DELETE);
                this.router.navigate(['Dashboard']);
                this.websocketAwareNeptuneService.disconnectFromWebsocket();
                this.websocketAwareNeptuneService.connectToWebsocket();
                // HACK: refresh the page after redirect, we do this because things don't handle refreshing data properly on loadUserState,
                // and localizations don't update either
                requestAnimationFrame(() => {
                    window.location.reload();
                });
                this.loading = false;
            }
        });
    }
}
